import React, { ReactElement, useReducer } from 'react';
import { AuthenticationContext, authenticationReducer, initialState } from 'hooks/authentication';

const AuthenticationProvider: React.FC<PropsWithChildren> = ({ children }): ReactElement => {
  const [authenticationState, dispatchAuthenticationAction] = useReducer(
    authenticationReducer,
    initialState,
  );
  return (
    <AuthenticationContext.Provider value={{ authenticationState, dispatchAuthenticationAction }}>
      {children}
    </AuthenticationContext.Provider>
  );
};

export default AuthenticationProvider;
